module.exports = __webpack_public_path__ + "img/locked-dark.cc88db0a.svg";